// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IStateInfoDto } from './IStateInfoDto';
import {
    IStateInfoDtoFromJSON,
    IStateInfoDtoFromJSONTyped,
    IStateInfoDtoToJSON,
    IStateInfoDtoToJSONTyped,
} from './IStateInfoDto';
import type { ICountryInfoDto } from './ICountryInfoDto';
import {
    ICountryInfoDtoFromJSON,
    ICountryInfoDtoFromJSONTyped,
    ICountryInfoDtoToJSON,
    ICountryInfoDtoToJSONTyped,
} from './ICountryInfoDto';

/**
 * 
 * @export
 * @interface IProviderAddressInfoDto
 */
export interface IProviderAddressInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof IProviderAddressInfoDto
     */
    validated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IProviderAddressInfoDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof IProviderAddressInfoDto
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IProviderAddressInfoDto
     */
    line3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IProviderAddressInfoDto
     */
    line4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IProviderAddressInfoDto
     */
    city: string;
    /**
     * 
     * @type {IStateInfoDto}
     * @memberof IProviderAddressInfoDto
     */
    state: IStateInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IProviderAddressInfoDto
     */
    zipcode: string;
    /**
     * 
     * @type {ICountryInfoDto}
     * @memberof IProviderAddressInfoDto
     */
    country?: ICountryInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IProviderAddressInfoDto
     */
    address_type: IProviderAddressInfoDtoAddressTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IProviderAddressInfoDtoAddressTypeEnum {
    PO_BOX = 'PO_BOX',
    RESIDENTIAL = 'RESIDENTIAL',
    BUSINESS = 'BUSINESS',
    UNKNOWN = 'UNKNOWN'
}


/**
 * Check if a given object implements the IProviderAddressInfoDto interface.
 */
export function instanceOfIProviderAddressInfoDto(value: object): value is IProviderAddressInfoDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    if (!('address_type' in value) || value['address_type'] === undefined) return false;
    return true;
}

export function IProviderAddressInfoDtoFromJSON(json: any): IProviderAddressInfoDto {
    return IProviderAddressInfoDtoFromJSONTyped(json, false);
}

export function IProviderAddressInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProviderAddressInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'validated': json['validated'] == null ? undefined : json['validated'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'line4': json['line4'] == null ? undefined : json['line4'],
        'city': json['city'],
        'state': IStateInfoDtoFromJSON(json['state']),
        'zipcode': json['zipcode'],
        'country': json['country'] == null ? undefined : ICountryInfoDtoFromJSON(json['country']),
        'address_type': json['address_type'],
    };
}

export function IProviderAddressInfoDtoToJSON(json: any): IProviderAddressInfoDto {
    return IProviderAddressInfoDtoToJSONTyped(json, false);
}

export function IProviderAddressInfoDtoToJSONTyped(value?: IProviderAddressInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validated': value['validated'],
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'line4': value['line4'],
        'city': value['city'],
        'state': IStateInfoDtoToJSON(value['state']),
        'zipcode': value['zipcode'],
        'country': ICountryInfoDtoToJSON(value['country']),
        'address_type': value['address_type'],
    };
}

